var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColouredDiamond({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4vw",
    height: "1.4vw",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1305 9.23438L11.9344 12.3334L14.0004 18.7659M14.0004 18.7659L16.1208 12.279L14.979 9.23438M14.0004 18.7659L8.40039 12.3878M14.0004 18.7659L19.6004 12.3878M8.40039 12.3878L10.7926 9.23438H17.2625L19.6004 12.3878M8.40039 12.3878H19.6004",
    stroke: "#40D2FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColouredDiamond);
export default __webpack_public_path__ + "static/media/coloured_diamond.51185ecc68eeeadf5eaa884a9fdc651e.svg";
export { ForwardRef as ReactComponent };